import React from 'react';

import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { ContractTermSection } from 'src/components/shared/ContractTermSection';
import { IAdRevShare } from 'src/types/IRateCard';

import { ViewConversionModel } from '../ViewConversionModel';
import { ViewPlayType } from '../ViewPlayType';
import './ViewAdRevShare.scss';

interface IViewAdRevShareProps {
    adRevShare: IAdRevShare;
    serviceId: number;
}

export const ViewAdRevShare = ({ adRevShare, serviceId }: IViewAdRevShareProps) => {
    return (
        <Column>
            <Text type="h500">Advertising revenue share vs cost per play</Text>
            <ContractTermSection title={'Advertising revenue share'}>
                <Column spacing="100">
                    <Text type="b200">Revenue share percentage</Text>
                    <Text type="b300">{adRevShare.revSharePercent}</Text>
                </Column>
            </ContractTermSection>
            {serviceId === 3 && <ViewPlayType playTypes={adRevShare.playTypes} />}
            {serviceId === 3 && <ViewConversionModel conversion={adRevShare.conversions?.[0]} serviceId={serviceId} />}
        </Column>
    );
};
